module.exports = __webpack_public_path__ + "img/base.77ba8d65.png";